import { render, staticRenderFns } from "./GetInTouchForm.vue?vue&type=template&id=d3f226f2&scoped=true&"
import script from "./GetInTouchForm.vue?vue&type=script&lang=js&"
export * from "./GetInTouchForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d3f226f2",
  null
  
)

export default component.exports